'use client';

import { c as _c } from "react/compiler-runtime";
import type { useFundingInlineCheckout } from '@morfi/onramp-sdk/react';
import type { MoonPayWebProvider } from '@morfi/onramp-sdk/web';
import type { ReactNode } from 'react';
import { FundingOperationProgress } from '../history/funding-operation-progress';
import { FundingProviderFrame } from './funding-provider-frame';
import { FundingHostedReview } from './hosted/funding-hosted-review';
interface Props {
  checkout: ReturnType<typeof useFundingInlineCheckout>;
  provider: MoonPayWebProvider;
}
export function FundingPaymentReview(t0) {
  const $ = _c(16);
  const {
    checkout,
    provider
  } = t0;
  let t1;
  if ($[0] !== checkout) {
    t1 = checkout.method === "sepa" && checkout.state === "review" ? <FundingHostedReview checkout={checkout} /> : null;
    $[0] = checkout;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== checkout.changeMethod || $[3] !== checkout.method || $[4] !== checkout.operation || $[5] !== checkout.review || $[6] !== checkout.state || $[7] !== checkout.viewPaymentStatus) {
    t2 = checkout.method === "card" && checkout.state === "payment" && checkout.operation ? <FundingOperationProgress operation={checkout.operation} {...checkout.review ? {
      quoted: {
        operationId: checkout.operation.id,
        review: checkout.review
      }
    } : {}} onReceipt={checkout.viewPaymentStatus} onTryAnotherMethod={checkout.changeMethod} /> : null;
    $[2] = checkout.changeMethod;
    $[3] = checkout.method;
    $[4] = checkout.operation;
    $[5] = checkout.review;
    $[6] = checkout.state;
    $[7] = checkout.viewPaymentStatus;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== checkout || $[10] !== provider) {
    t3 = (checkout.method === "card" || checkout.method === "sepa") && checkout.paymentSignature && checkout.attemptId ? <div hidden={checkout.method === "card" || checkout.state !== "payment"} aria-hidden={checkout.method === "card" || checkout.state !== "payment"}><FundingProviderFrame key={checkout.attemptId} provider={provider} checkout={checkout} mode="payment" /></div> : null;
    $[9] = checkout;
    $[10] = provider;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  let t4;
  if ($[12] !== t1 || $[13] !== t2 || $[14] !== t3) {
    t4 = <>{t1}{t2}{t3}</>;
    $[12] = t1;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
}